import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormViewModel } from "../form-view.model";

export interface FormViewDialogData {
    form: FormViewModel;
    definition?: string;
    patientName?: string;
}
@Component({
    selector: "form-view-dialog",
    templateUrl: "./form-view-dialog.component.html",
    encapsulation: ViewEncapsulation.None,
    styles: [
        /* language=SCSS */ `
            .form-view-dialog {
                .mat-mdc-dialog-container {
                    width: 50vw !important;
                    height: 96vh !important;
                    padding: 0 !important;
                    overflow: hidden !important;
                }
                .mat-mdc-dialog-surface {
                    height: 100% !important;
                    overflow: hidden !important;
                }
            }
        `,
    ],
})
export class FormViewDialogComponent {
    public form: FormViewModel;

    public definition: string | undefined;

    constructor(public dialogRef: MatDialogRef<FormViewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.dialogRef.addPanelClass("form-view-dialog");
        this.form = data.form;
        this.definition = data.definition;
    }
}
